import { Injectable, inject } from '@angular/core';
import { first, map, mergeMap } from 'rxjs';
import { EffectsBase } from 'clicklease-ui-elements';
import { RoseService } from '../../services';
import {
    getRoseKeySelector,
    LoadBankAccountListAction,
    SetBankAccountListAction
} from '../../ngrx';

@Injectable()
export class BankAccountEffectsService extends EffectsBase {
    readonly #roseService = inject(RoseService);
    readonly #roseKey = this.store.selectSignal(getRoseKeySelector);

    public readonly doLoadBankAccountList = this.createEffect(() => 
        this.actions.pipe(
            this.ofType(LoadBankAccountListAction),
            mergeMap(() => this.loadBankAccountList())
        )
    );

    private loadBankAccountList() {
        return this.#roseService.getBankInformation(this.#roseKey()).pipe(
            map((list) => SetBankAccountListAction({ list })),
            first()
        );
    }
}